import React from "react";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";

const Surface = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff4e6",
  borderRadius: "7px",
}));

export default Surface;
